module.exports = __webpack_public_path__ + "img/ethiopia.6c1bd7db.svg";